import React, { ComponentType } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import withTheme from '@material-ui/core/styles/withTheme';
import { styles } from '../../core/Shared/ListSlick';
import BaseListSlick, {
  Props as BaseProps,
} from '../../core/Businesses/PlanListSlick';
import Card from '../Plans/Card';

type Props = BaseProps & {
  isAuthenticated: boolean;
};

class PlanListSlick extends BaseListSlick {
  props: Props;

  slickItemsRenderer() {
    const { classes, plans = [], isAuthenticated } = this.props;
    return plans.map((plan, index) => (
      <Card
        key={`business-plan-list-slick${index}`}
        fixTermTextLine
        isAuthenticated={isAuthenticated}
        className={classes.card}
        {...plan}
      />
    ));
  }
}

export default withTheme(
  withStyles(styles)(PlanListSlick),
) as ComponentType<Props>;
